import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { SvgIcon, Modal, Select, SvgBorder, Button } from '@/components';
import { urlQuery, uuid, getFileExtension } from '@/shared/utils/tools';
import Tabs, { TabPane } from 'rc-tabs';
import Message from 'rc-message';
import ImageUpload from '../ImageUpload';
import {
  apiService,
  WidgetImplInfoProps,
  AppInfo,
  WidgetInfo,
  WidgetDetile,
  itemResultList,
  languageList,
  multiLangParse,
} from '@/shared';
import {
  styleMap,
  languageMap,
  ZHCN_CODE,
  ZHTW_CODE,
  BOCN_CODE,
  UGCN_CODE,
} from '../const';
import classnames from 'classnames';
import { getBytesLength } from '@/shared/utils/tools';
import { emojiReg, commaReg } from '@/shared/utils/reg';
import { useImmer } from 'use-immer';
import './multilan-edit-modal.less';
import MultiLanTag from '../MultiLanTag';
import Upload from 'rc-upload';
export enum EditModalSourceType {
  /** 编辑 */
  Edit,
  /** 更新 */
  Update,
  /** 查看 */
  View,
}

export type SourceType =
  | EditModalSourceType
  | {
      type: EditModalSourceType;
      /** 强制禁用表单 */
      formDisable?: boolean;
    };
interface MultiLanEditModalProps {
  info: WidgetInfo;
  appInfo: AppInfo;
  visible: boolean;
  className?: string;
  showBg?: boolean;
  style?: React.CSSProperties;
  bgClick?: () => void;
  close?: (bool: boolean) => void;
  /** 打开弹窗的方式来源，是编辑还是上线后更新资料 */
  source: SourceType;
}
interface PreviewImgBtnProps {
  onClick?: () => void;
}
type CodeType = string;
interface SelectedLanFormProps {
  show: boolean;
  langCode: string;
  collaped: boolean;
  lightModeUrl: string;
  darkModeUrl: string;
  dispAppName: string;
  widgetName: string;
  widgetDesc: string;
}
interface previewObjProps {
  previewImg: string;
  textareaValue: string;
}
interface StatusRefProps {
  /** 记录是粘贴状态 */
  onPastingFlag: boolean;
}
// 输入的最大字数 ，汉字 22个 其他的44
const getMaxLen = (code: string) =>
  [ZHCN_CODE, ZHTW_CODE].includes(code) ? 22 : 44;
// 多语言默认参数
const defaultSeletedLanFormInfo: SelectedLanFormProps[] = Array.from(
  languageMap.keys(),
).map((item: CodeType) => ({
  show: false, //显示与否，因为弹窗不关闭，临时删除需要保存已经填写的内容
  langCode: item, // 对应接口languaue字段
  collaped: false, //是否折叠
  textareaValue: '', // 描述信息
  lightModeUrl: '', // 浅色图
  darkModeUrl: '', // 深色图
  dispAppName: '', //应用名称
  widgetDesc: '', //小部件介绍
  widgetName: '', //小部件名称
}));
const MultiLanEditModal: FC<MultiLanEditModalProps> = ({
  info,
  appInfo = {} as AppInfo,
  visible = false,
  className = '',
  close = (bool: boolean) => {},
  source = EditModalSourceType.Edit,
  ...rest
}) => {
  const getSourceType = (source: SourceType) =>
    typeof source === 'object' ? source.type : source;
  /** 强制禁用表单 */
  const formDisable = typeof source === 'object' && source.formDisable;
  /** 是否禁用表单编辑 */
  const disabled: boolean =
    getSourceType(source) === EditModalSourceType.View || !!formDisable;
  /** 已上线的时候更新资料 */
  const isPublishedUpdate: boolean =
    getSourceType(source) === EditModalSourceType.Update;
  // 预览
  const defaultPreviewObj = {
    previewImg: '',
    textareaValue: '',
  };
  const [previewVisible, setPreviewVisible] = useState<boolean>(false);
  const [previewObj, setpreviewObj] = useImmer<previewObjProps>(
    defaultPreviewObj,
  );
  const { appPkgName, appVerCode, updateType } = urlQuery(); // 从url取的参数
  // 机型
  const [phoneModelArr, setPhoneModelArr] = useImmer<string[]>([]); // 转换后的机型数组
  const [phoneModelInputValue, setPhoneModelInputValue] = useImmer<string>(''); //临时输入的机型字符串

  // 多语言信息
  const [selectedLanFormInfo, setSelectedLanFormInfo] = useImmer<
    SelectedLanFormProps[]
  >(defaultSeletedLanFormInfo);
  const [selectCountry, setSelectCountry] = useState<string[]>([]);
  //国家列表
  const [countryList, setCountryList] = useState<itemResultList[]>([]);
  const [languageList, setLanguageList] = useState<languageList[]>([]);
  const [detile, setDetile] = useState<WidgetDetile>(); //小部件详情
  const lang = localStorage.getItem('language'); //查看当前的语言
  const [mulLangParse, setMulLangParse] = useState<multiLangParse>({});

  // 只填了描述和浅色图就可以提交
  const ac =
    selectedLanFormInfo
      .filter((d) => d.show)
      .every((item: SelectedLanFormProps) => {
        return (
          item.widgetDesc &&
          item.lightModeUrl &&
          item.dispAppName &&
          item.widgetName
        );
      }) && !disabled;
  // 关闭弹窗后清除缓存
  const clear = useCallback(() => {
    setSelectedLanFormInfo(defaultSeletedLanFormInfo);
  }, [setSelectedLanFormInfo]);

  const PreviewImgBtn: FC<PreviewImgBtnProps> = ({ onClick = () => {} }) => {
    return (
      <div className="preview-img-btn flex-center" onClick={onClick}>
        <SvgIcon
          style={{ fill: '#48577D' }}
          name="preview-pic"
          width="20"
          height="20"
        />
        <span>{ window.trans('preview-widget')}</span>
      </div>
    );
  };
  
  // 获取应用编辑页配置信息-判断是否展示发布机型模块
  const getAppEditConf = useCallback(async () => {
    const res = await apiService.getAppEditConfig({
      id: info.id,
    });
    if (res) {
      setDetile(res);
    }
    if(Array.isArray(res?.regions)) {
      setSelectCountry(res.regions)
    }else {
      setSelectCountry([])
    }
    if (res?.multiLangList?.length) {
      res.multiLangList.forEach((d) => {
        setSingleDataFn(d.langCode, {
          show: true,
          collaped: false,
          widgetDesc: d.widgetLangItem.widgetDesc,
          widgetName: d.widgetLangItem.widgetName,
          dispAppName: d.widgetLangItem.dispAppName,
          lightModeUrl: d.widgetLangItem.lightModeUrl,
          darkModeUrl: d.widgetLangItem.darkModeUrl,
        });
      });
    }
  }, [info]);

  // 更新
  const updateAbilityImplFn = useCallback(async () => {
    if (selectCountry.length < 1) {
      Message.error({
        content: window.trans('please-select'),
      });
      return;
    }
    const showLan = selectedLanFormInfo.filter(
      (d: SelectedLanFormProps) => d.show,
    );
    if (showLan.length < 1) {
      Message.error({
        content: window.trans('least-one-language'),
      });
      return;
    }
    try {
      const res = await apiService.updateAbilityImpl({
        regionList: [...selectCountry],
        id: info.id,
        multiLangList: selectedLanFormInfo
          .filter((d: SelectedLanFormProps) => d.show)
          .map((d: SelectedLanFormProps) => ({
            langCode: d.langCode,
            widgetLangItem: {
              widgetDesc: d.widgetDesc,
              dispAppName: d.dispAppName,
              widgetName: d.widgetName,
              lightModeUrl: d.lightModeUrl,
              darkModeUrl: d.darkModeUrl,
            },
          })),
      });
      if (res) {
        Modal.success({
          afterClose: () => {
            close(true);
            clear();
          },
        });
      }
    } catch (error) {
      Modal.error({
        afterClose: () => {
          close(true);
          clear();
        },
      });
    }
  }, [
    info,
    close,
    clear,
    selectedLanFormInfo,
    isPublishedUpdate,
    selectCountry,
  ]);
  // 多语言-更新单条数据
  const setSingleDataFn = useCallback(
    (code: string, param: Partial<SelectedLanFormProps>) => {
      setSelectedLanFormInfo((draft) => {
        const f = draft.find((d) => d.langCode === code);
        if (f) {
          Object.assign(f, param);
        }
      });
    },
    [setSelectedLanFormInfo],
  );

  const getCountryList = useCallback(async () => {
    if (visible && appInfo) {
      const res = await apiService.getCountryList({
        appPkgName: appPkgName as string,
        verCode: appVerCode as string,
      });
      if (res) {
        setCountryList(res.itemResultList);
      }
    }
  }, [visible, appPkgName, appVerCode]);

  const getEnumList = useCallback(async () => {
    if (visible && appInfo) {
      const res = await apiService.getEnumList();
      if (res) {
        const langList = Object.keys(res.LangLocale).map((item) => ({
          key: item,
          value: res.LangLocale[item],
        }));
        setLanguageList(langList);
      }
    }
  }, [visible]);
  // 选择语言
  const lanChangeFn = useCallback(
    (code: string) => {
      setSelectedLanFormInfo((draft) => {
        const idx = draft.findIndex((d) => d.langCode === code);
        const target = draft[idx];
        if (target.show) {
          target.show = false;
        } else {
          const remove = draft.splice(idx, 1)[0];
          draft.push(Object.assign(remove, { show: true }));
        }
      });
    },
    [setSelectedLanFormInfo],
  );

  // 选择国家
  const CouChangeFn = useCallback(
    (code: string) => {
      const selectCountryTemp = [...selectCountry];
      const idx = selectCountryTemp.indexOf(code);
      if (idx > -1) {
        selectCountryTemp.splice(idx, 1);
      } else {
        selectCountryTemp.push(code);
      }
      setSelectCountry([...selectCountryTemp]);
    },
    [setSelectCountry, selectCountry],
  );

  // 每次打开弹窗：获取用户配置信息
  useEffect(() => {
    if (visible && info.status !== 1) {
      getAppEditConf();
    }
    if(visible && info.status === 1) {
      setSelectCountry([]);
    }
    visible && getCountryList();
    // visible && getEnumList();
  }, [visible, getAppEditConf, getCountryList]);
  // 字符串根据逗号转数组
  const phoneModelInputHandle = (value: string) => {
    if (!value) return;
    const splitArr = value
      .split(commaReg)
      .filter(Boolean)
      .map((d) => d.trim());
    setPhoneModelArr((draft) => {
      draft.push(...splitArr);
    });
    setPhoneModelInputValue('');
  };
  const cRefs = useRef<StatusRefProps>({ onPastingFlag: false }).current; // 记录是粘贴状态

  //关闭预览弹窗
  const closePreviewModal = () => {
    setPreviewVisible(false);
    setpreviewObj(defaultPreviewObj);
  };

  //上传多语言包
  const uploadLanguage = async (file: File) => {
    if(file.type !=='text/xml') {
      Message.error({
        content: window.trans('upload-xml-tips'),
      });
      return;
    }
    const newName = uuid() + getFileExtension(file.name);
    const newFile = new File([file], newName, {
      type: file.type,
    });
    const res = await apiService.uploadLanguageParse(newFile);
    if (res) {
      const langParse = Object.values(res).map(item => ({
        show: true,
        langCode: item.lan, // 对应接口languaue字段
        collaped: false, //是否折叠
        textareaValue: '', // 描述信息
        lightModeUrl: '', // 浅色图
        darkModeUrl: '', // 深色图
        dispAppName: item.author, //应用名称
        widgetDesc: item.desc, //小部件介绍
        widgetName: item.title, //小部件名称
      }))
      // const langParseTemp = langParse.
      setSelectedLanFormInfo(langParse);
    }
  };
  
  return (
    <>
      {/* 预览 */}
      <Modal
        maskClosable={true}
        visible={previewVisible}
        onClose={closePreviewModal}
        className={`widget-edit-preview-img-modal2`}
      >
        <SvgIcon
          className="cursor"
          style={{ fill: '#fff' }}
          name="phone-sys-top-ui"
          width="300"
          height="30"
        />
        <div className="modal-content">
          <div className="top">
            <div className="ganzi"></div>
          </div>
          <div className="nav pr">
            <SvgIcon
              className="to-left-arrow pa cursor"
              style={{ fill: '#000' }}
              name="to-left-arrow"
              width="30"
              height="30"
              onClick={closePreviewModal}
            />
            <div className="flex-center">
              <img className="appIcon" src={appInfo.icon} alt="" />
              <span>{appInfo.appName}</span>
            </div>
          </div>
          {/*  */}
          <div className="flex1 flex flex-column">
            <p className="p-1 tc">{info.name}</p>
            <p className="p-2 tc">{previewObj.textareaValue}</p>
            <div className="flex1 flex-center">
              <div
                className={classnames('img-mid-box', {
                  ['style' + info.size]: info.size,
                })}
              >
                <img src={previewObj.previewImg} alt="" />
              </div>
            </div>
          </div>
          <div className="bottom-btn flex-center">
            <span>{window.trans('add-to-desk')}</span>
          </div>
        </div>
      </Modal>
      {/* 编辑弹窗2期多语言 */}
      <Modal
        destroyOnClose
        visible={visible}
        className={`${className} widget-edit-modal2`}
        {...rest}
      >
        <div className="ww">
          {/* 小部件信息 */}
          <div className="widget-info">
            <div className="info" style={{ width: '180px' }}>
              <span className="name">{info.name}</span>
            </div>
            <div className="info" style={{ padding: '10px' }}>
              <span className="name">ID</span>
              <span className="cont">{info.widgetId}</span>
            </div>
            <div className="info" style={{ width: '120px' }}>
              <span className="name">{window.trans('size')}</span>
              <span className="cont">
                {info.size}
                {/* {styleMap.get(info.style)?.styleName} */}
              </span>
            </div>
            <div className="info" style={{ paddingRight: '30px' }}>
              <span className="name">{window.trans('widget-version')}</span>
              <span className="cont">
                {(appInfo.currVer && appInfo.currVer.verName) || ''}
              </span>
            </div>
          </div>
          {/* 发布国家 */}
          <div className="widget-lang">
            <div  className="widget-langSelect">
              <div className="info">
                <span className="name">{window.trans('published-region')}</span>
              </div>
              <Select
                className="choice-lan-version-select"
                customContent={
                  <div className="choice-lan-version-btn flex-center">
                    <div className="add-div"></div>
                    <span className="c">{ window.trans('choose-country' )}</span>
                  </div>
                }
                disabled={disabled}
                selectedKeys={selectCountry}
                options={countryList.map((item: itemResultList) => ({
                  key: item.code,
                  value: lang === 'cn' ? item.cnName : item.name,
                }))}
                multi={true}
                onChange={(value, key: string) => {
                  // if (key === ZHCN_CODE) return;
                  CouChangeFn(key);
                }}
              ></Select>
            </div>
            <div className="lan-tag-box flex1 flex-start">
              {selectCountry.map((item: string, index: number) => (
                <MultiLanTag
                  close={true}
                  key={index}
                  disabled={disabled}
                  value={
                    lang === 'cn'
                      ? countryList.filter((item1) => item1.code === item)[0]
                          .cnName
                      : countryList.filter((item1) => item1.code === item)[0]
                          .name
                  }
                  onClose={() => {
                    CouChangeFn(item);
                  }}
                />
              ))}
            </div>
          </div>
          {/* 多语言 */}
          <div className="widget-lang">
            <div className="widget-langSelect">
              <div className="info">
                <span className="name">
                  {window.trans('local-language-setting')}
                </span>
              </div>
              <Select
                className="choice-lan-version-select"
                customContent={
                  <div className="choice-lan-version-btn flex-center">
                    <div className="add-div"></div>
                    <span className="c">{window.trans('choose-language')}</span>
                  </div>
                }
                disabled={disabled}
                selectedKeys={selectedLanFormInfo
                  .filter((d) => d.show)
                  .map((d) => d.langCode)}
                options={Array.from(languageMap.keys()).map((key: string) => ({
                  key,
                  value: languageMap.get(key),
                }))}
                multi={true}
                onChange={(value, key: string) => {
                  if (key === ZHCN_CODE) return;
                  lanChangeFn(key);
                }}
              ></Select>
              <Upload
                className="custom-upload-btn"
                // onChange={uploadImage}
                disabled={disabled}
                customRequest={(options: any) => {
                  uploadLanguage(options?.file);
                }}
              >
                <div className="choice-lan-btn">
                  <span className="c">
                    {window.trans('upload-more-language')}
                  </span>
                </div>
              </Upload>
            </div>
            <div className="lan-tag-box">
              {selectedLanFormInfo
                .filter((d) => d.show)
                .map((item: SelectedLanFormProps, index: number) => (
                  <MultiLanTag
                    close={item.langCode !== ZHCN_CODE}
                    key={index}
                    disabled={disabled}
                    value={languageMap.get(item.langCode)}
                    onClose={() => {
                      lanChangeFn(item.langCode);
                    }}
                  />
                ))}
            </div>
            
          </div>
          {/* 温馨提示 */}
          {/* <div className="tip-div">
            <div className="top flex-start">
              <SvgIcon
                className="cursor"
                style={{ fill: '#0476EB' }}
                name="error"
                width="30"
                height="30"
              />
              <span className="t">{window.trans('review-tips')}:</span>
            </div>
            <p>
              若您的应用分发中国大陆，则小部件介绍必须填写「中文（简体）」信息；若您的应用分发海外，则小部件介绍必须填写「English」或所在国家语言中的任一语言。
            </p>
          </div> */}
          {/* Collapse */}
          <Tabs
            // defaultActiveKey="zh_CN"
            className="language-collape-wrapper"
          >
            {selectedLanFormInfo
              .filter((d) => d.show)
              .map((item: SelectedLanFormProps) => {
                const {
                  lightModeUrl,
                  darkModeUrl,
                  collaped,
                  langCode,
                  dispAppName,
                  widgetName,
                  widgetDesc,
                } = item;
                const done = widgetDesc && lightModeUrl; //已经填写
                const maxLen = getMaxLen(item.langCode);
                const isUGorBo = [BOCN_CODE, UGCN_CODE].includes(item.langCode); // 维语或者藏语
                return (
                  <TabPane
                    tab={languageMap.get(item.langCode)}
                    key={item.langCode}
                  >
                    <li
                      className={classnames('collape-li', {
                        collaped: collaped,
                      })}
                      key={item.langCode}
                    >
                      <div
                        className="h-div flex cursor"
                        onClick={() => {
                          setSelectedLanFormInfo((draft) => {
                            const f = draft.find(
                              (d) => d.langCode === item.langCode,
                            );
                            if (f) {
                              f.collaped = !f.collaped;
                            }
                          });
                        }}
                      >
                        <div className="flex flex1 cont">
                          <div className="flex1 string"></div>
                          <div className="center-c flex-center">
                            <span>{languageMap.get(item.langCode)}</span>
                            <div
                              className={classnames('status-tag tc', {
                                done: done,
                              })}
                            >
                              {done
                                ? window.trans('filled')
                                : window.trans('tobe-filled')}
                            </div>
                          </div>
                          <div className="flex1 string"></div>
                        </div>
                        <div className="toggle-btn tc">
                          <SvgIcon
                            className="cursor"
                            style={{ fill: '#F2F4F8' }}
                            name={collaped ? 'collapse-fold' : 'collapse-open'}
                            width="18"
                            height="30"
                          />
                        </div>
                      </div>
                      {/* content */}
                      <div className="collape-content">
                        <div className="widget-intro">
                          <label htmlFor="male">
                            {window.trans('app-name')}*
                          </label>
                          <div className="textarea-box">
                            <textarea
                              onChange={(e) => {
                                let value = e.target.value;
                                value = value.replace(emojiReg, '');
                                const bLen = getBytesLength(value);
                                if (bLen <= 100) {
                                  setSingleDataFn(langCode, {
                                    dispAppName: value,
                                  });
                                }
                              }}
                              disabled={disabled}
                              value={dispAppName}
                              className="textarea-intro"
                            ></textarea>
                            {isUGorBo ? null : (
                              <span className="num">
                                {/* 22个汉字 */}
                                {dispAppName
                                  ? getBytesLength(dispAppName) || 1
                                  : 0}
                                /{100}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="widget-intro">
                          <label htmlFor="male">{window.trans('component-name')}*</label>
                          <div className="textarea-box">
                            <textarea
                              onChange={(e) => {
                                let value = e.target.value;
                                value = value.replace(emojiReg, '');
                                const bLen = getBytesLength(value);
                                if (bLen <= 100) {
                                  setSingleDataFn(langCode, {
                                    widgetName: value,
                                  });
                                }
                              }}
                              disabled={disabled}
                              value={widgetName}
                              className="textarea-intro"
                            ></textarea>
                            {isUGorBo ? null : (
                              <span className="num">
                                {/* 22个汉字 */}
                                {widgetName
                                  ? getBytesLength(widgetName) || 1
                                  : 0}
                                /{100}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="widget-intro">
                          <label htmlFor="male">
                            {window.trans('widget-desc')}*
                          </label>
                          <div className="textarea-box">
                            <textarea
                              onChange={(e) => {
                                let value = e.target.value;
                                value = value.replace(emojiReg, '');
                                if (isUGorBo) {
                                  // 不限制维语和藏语
                                  setSingleDataFn(langCode, {
                                    widgetDesc: value,
                                  });
                                  return;
                                }
                                const bLen = getBytesLength(value);
                                if (bLen <= 100) {
                                  setSingleDataFn(langCode, {
                                    widgetDesc: value,
                                  });
                                }
                              }}
                              disabled={disabled}
                              value={widgetDesc}
                              className="textarea-intro"
                              placeholder={window.trans('widget-tips-placeholder')}
                            ></textarea>
                            {isUGorBo ? null : (
                              <span className="num">
                                {/* 22个汉字 */}
                                {widgetDesc
                                  ? getBytesLength(widgetDesc) || 1
                                  : 0}
                                /{100}
                              </span>
                            )}
                          </div>
                        </div>
                        <section className="pic-info">
                        <label htmlFor="male">
                            {window.trans('widget-store')}
                          </label>
                          <div className="dis">
                            {window.trans('widget-store-tips')}
                            {/* ；上传详情见
                          <a
                            rel="noreferrer"
                            target="_blank"
                            href="https://dev.mi.com/console/doc/detail?pId=2458"
                          >
                            展示图规则须知
                          </a> */}
                          </div>
                          <div className="upload-box flex-center">
                            <div
                              className="single-img-upload-outer"
                              style={{ marginRight: '58px' }}
                            >
                              <SvgBorder
                                noBorder={Boolean(lightModeUrl)}
                                color={'#0d84ff'}
                                rx={31.8}
                              >
                                <ImageUpload
                                  disabled={disabled}
                                  defaultUrl={lightModeUrl}
                                  getUrl={(lightModeUrl) => {
                                    setSingleDataFn(langCode, { lightModeUrl });
                                  }}
                                  imgStyle={info.size}
                                  className={classnames({
                                    ['style' + info.size]: info?.size,
                                  })}
                                  type="light"
                                />
                              </SvgBorder>
                              <div className="preview-img-btn-div">
                                {lightModeUrl && (
                                  <PreviewImgBtn
                                    onClick={() => {
                                      setpreviewObj((draft) => {
                                        draft.previewImg = lightModeUrl;
                                        draft.textareaValue = widgetDesc;
                                      });
                                      setPreviewVisible(true);
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="single-img-upload-outer">
                              <SvgBorder
                                noBorder={Boolean(darkModeUrl)}
                                color={'#61779a'}
                                rx={31.8}
                              >
                                <ImageUpload
                                  disabled={disabled}
                                  defaultUrl={darkModeUrl}
                                  imgStyle={info.size}
                                  className={classnames({
                                    ['style' + info?.size]: info?.size,
                                  })}
                                  getUrl={(darkModeUrl) => {
                                    setSingleDataFn(langCode, { darkModeUrl });
                                  }}
                                  type="dark"
                                />
                              </SvgBorder>
                              <div className="preview-img-btn-div">
                                {darkModeUrl && (
                                  <PreviewImgBtn
                                    onClick={() => {
                                      setpreviewObj((draft) => {
                                        draft.previewImg = darkModeUrl;
                                        draft.textareaValue = widgetDesc;
                                      });
                                      setPreviewVisible(true);
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </li>
                  </TabPane>
                );
              })}
          </Tabs>
          {/* opt */}
          <section className="opt-box flex-center">
            <Button
              className="back"
              onClick={() => {
                clear();
                close(false);
              }}
            >
              {window.trans('return')}
            </Button>
            <Button
              type="primary"
              disable={!ac}
              className={'save'}
              onClick={() => {
                updateAbilityImplFn();
              }}
            >
              {window.trans('save-widget')}
            </Button>
          </section>
        </div>
      </Modal>
    </>
  );
};

export default MultiLanEditModal;
